import { type PayloadAction, createReducer } from '@reduxjs/toolkit';
import {
    generateImageEnd,
    generateImageStart,
    incrementImageGenerationPercentage,
    resetImageGeneration,
} from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.actions';
import { aiPhotoGenerationHelper } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.helpers';
import {
    type IAiGenerationState,
    type IGenerateImageEnd,
    EAiPhotoGenerationState,
} from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';

const initialState: IAiGenerationState = {
    generation: {
        state: EAiPhotoGenerationState.idle,
    },
};

export const aiPhotoGenerationReducer = createReducer(initialState, {
    [generateImageStart.type]: (state) => {
        state.generation = {
            state: EAiPhotoGenerationState.proccess,
            percentage: 1,
        };
    },
    [generateImageEnd.type]: (state, action: PayloadAction<IGenerateImageEnd>) => {
        const { image, size } = action.payload;

        state.generation = {
            state: EAiPhotoGenerationState.complete,
            percentage: 100,
            image,
            size,
        };
    },
    [resetImageGeneration.type]: (state) => {
        aiPhotoGenerationHelper.resetImageData();
        state.generation = {
            state: EAiPhotoGenerationState.idle,
        };
    },
    [incrementImageGenerationPercentage.type]: (state) => {
        if (state.generation.percentage && state.generation.percentage < 99) {
            state.generation.percentage += 1;
        }
    },
});
